import { Component, OnInit } from '@angular/core';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router } from '@angular/router';
import { NgModule } from '@angular/core';
const swal = require('sweetalert');
@Component({
  selector: 'app-payoutlayout',
  templateUrl: './payoutlayout.component.html',
  styleUrls: ['./payoutlayout.component.scss']
})
export class PayoutlayoutComponent implements OnInit {

  constructor(private bnIdle: BnNgIdleService, private router: Router) { }

  ngOnInit() {
  }

}
